import { styled } from "@linaria/react";
import React, { ButtonHTMLAttributes, HTMLAttributes } from "react";
import { themeDefault } from "src/theme-revamp";

interface IFlatButtonProps
  extends React.PropsWithoutRef<ButtonHTMLAttributes<HTMLButtonElement>> {
  isActive?: boolean;
  maxWidth: string;
}

function FlatButton({ isActive = true, ...props }: IFlatButtonProps) {
  return <Button isActive={isActive} {...props} />;
}

export default FlatButton;

const Button = styled.button<{ isActive: boolean }>`
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) =>
    props.isActive
      ? themeDefault.colors.primary
      : themeDefault.colors.grey[700]};
  cursor: pointer;
  padding: 8px;
  width: 100%;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  color: ${(props) =>
    props.isActive
      ? themeDefault.colors.white
      : themeDefault.colors.grey[1200]};
  border: ${(props) =>
      props.isActive
        ? themeDefault.colors.primary
        : themeDefault.colors.grey[700]}
    solid;
  border-radius: 100rem;
  transition: all 0.3s linear;
  &:hover {
    background-color: #883E89;
    border: 1px solid #883E89;
    color: #FFFFFF;
  }
`;
